/*** IMPORTS FROM imports-loader ***/
(function() {
var mp = window.mp;
var exports = undefined;
var define = undefined;
var module = undefined;

/* eslint camelcase: 0, no-unused-vars: 0, no-use-before-define: 0, no-var: 0 */
/* globals _, mp */

/*
 * Provides:
 *  mp.widgets.dropdowns.Filterable
 *
 * Requires:
 *  mp.widgets.dropdowns.base
 *  mp.widgets.styled_labels
 *  mp.widgets.dropdowns.rounded
 *  jquery.scrollTo
 *  underscore.mixins
 *  underscore.string
 */

_.namespace(`mp.widgets.dropdowns`, function(ns) {
  'use strict';

  function Filterable() {
    this.class_name = `filterable_dropdown`;
    this.label_class = mp.widgets.styled_labels.Rounded;
    this.body_class = Body;
  }
  _.inherit(Filterable, mp.widgets.Dropdown);

  Filterable.prototype.default_config = function() {
    return _.extend(Filterable.superclass.default_config.call(this), {
      emulate_select: true,
      menu: true,
    });
  };

  Filterable.prototype.bindings = function() {
    Filterable.superclass.bindings.apply(this, arguments);

    this.body.container.delegate(`.search_box`, `keydown`, _.bind(this.handle_keydown, this));

  };

  Filterable.prototype.handle_keydown = function(ev) {
    switch (ev.which) {
      case 27: // esc
        if (this.label.item && typeof(this.label.item) !== `string`) {
          this.body.select_item(this.label.item, true);
        }
        this.deactivate();
        ev.stopPropagation();
        break;
      case 9: // tab
      case 13: // enter
        this.select_and_deactivate();
        break;
      case 38: // up
        this.body.select_previous();
        ev.preventDefault();
        break;
      case 40: // down
        this.body.select_next();
        ev.preventDefault();
        break;
    }
  };

  Filterable.prototype.select_and_deactivate = function() {
    this.deactivate();
    var selected = this.body.selected();
    if (selected && (this.label.item !== selected) && !_.isArray(selected)) {
      this.label.select(selected);
      this.body.select_item(selected);
    }
  };

  function Body() {
    this.class_name = `filterable_dropdown_body`;
    this.item_class = mp.widgets.dropdowns.Rounded.Item;
  }
  _.inherit(Body, mp.widgets.Dropdown.Body);

  Body.prototype.create = function(div, config) {
    Body.superclass.create.call(this, div, config);

    if (!this.config.collapse) {
      this.container.css(`min-width`, this.config.min_width + 38);
    }

    var search_container = $(`<div>`).addClass(`search_box_container`);
    this.search = $(`<input />`).addClass(`search_box`);

    var placeholder = config.placeholder || this.placeholder;
    if (placeholder) {
      this.search.attr(`placeholder`, placeholder);
    }

    this.content = $(`<div>`).addClass(`content`);

    this.container.append(
      search_container.append(this.search),
      this.content
    );

    this.appendTo = this.content;
    return this;
  };

  Body.prototype.bindings = function() {
    Body.superclass.bindings.apply(this, arguments);

    this.container.delegate(`.search_box`, `keyup`,
      _.bind(this.filter, this));
  };

  Body.prototype.visible = function() {
    var items = [];
    _.each(this.widgets, function(item) {
      if (item.container.is(`:visible`)) { items.push(item); }
    });
    return items;
  };

  Body.prototype.get_matching_regex = function(query) {
    // replace all regex special characters with their escaped version; $& means the whole matched string
    // attribution: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
    var escaped_query = query.replace(/[.*+?^${}()|[\]\\]/g, `\\$&`);
    return new RegExp(`(?:^|(-|\\.|_|\\s)+)(` + escaped_query + `)`, `i`);
  };

  // Given a query string, returns a filter predicate
  // against strings. Exposed and separate so we can export it.
  var filter_predicate_from_query = function(query) {
    var regex = Body.prototype.get_matching_regex(query);
    return function(check_string) {
      return regex.test(check_string);
    };
  };

  Body.prototype.filter = function(ev, skip_select) {
    this.reset_progressive_scroll();

    if (ev && _.include([9, 13, 38, 40], ev.which)) {
      // the above key codes are esc/enter/up/down
      ev.preventDefault();
      return;
    }

    var query = this.search.val();
    var predicate = filter_predicate_from_query(query);

    // Log only once, when the search input box is used.
    if (!_.isUndefined(ev) && (!this.search_tracked)) {
      this.container.trigger(`search-used`, query);
      this.search_tracked = true;
    }

    _.each(this.widgets, function(item) {
      var display_val = item.display_value;
      if ( predicate(display_val) ) {
        item.container.show();
      } else {
        item.container.hide();
      }
    });

    if ((this.widgets.length > 0) && !_.isUndefined(ev)) {
      // If the currently selected item is still visible, don't reselect
      var selected = this.selected();
      if (selected && this.selected().container.is(`:visible`)) { return; }

      // Otherwise, select the first visible
      var next = _.find(this.widgets, function(item) {
        return item.container.is(`:visible`);
      });
      if (next) { this.select_item(next, true); }
    }
  };

  Body.prototype.activate = function() {
    Body.superclass.activate.apply(this, arguments);

    this.scroll_to_selected();

    this.search.attr(`value`, ``).focus();
    this.filter(undefined, true);

    return this;
  };

  Body.prototype.scroll_to_selected = function() {
    var selected = this.selected();
    if (selected && !_.isArray(selected)) {
      this.appendTo.parent().scrollTo(selected.container, {
        offset: {
          top: -10 * selected.container.height(),
        },
      });
    }
  };

  Body.prototype.select_item = function(item, skip_event) {
    Body.superclass.select_item.apply(this, arguments);

    this.scroll_to_selected();
  };

  Body.prototype.select_next = function() {
    var selected = this.selected();
    if (_.isArray(selected)) { return; }

    var index = _.indexOf(this.widgets, selected);
    if (index < this.widgets.length - 1) {
      var next = _.find(this.widgets.slice(index+1), function(item) {
        return item.container.is(`:visible`) && item.enabled;
      });
      if (next) { this.select_item(next, true); }
    }
  };

  Body.prototype.select_previous = function() {
    var selected = this.selected();
    if (!selected) { selected = this.widgets[this.widgets.length - 1]; }
    else if (_.isArray(selected)) { return; }

    // reverse modifies the original array, so we need to clone it
    var items = _.toArray(this.widgets).reverse();

    var index = _.indexOf(items, selected);
    if (index < items.length - 1) {
      var next = _.find(items.slice(index+1), function(item) {
        return item.container.is(`:visible`) && item.enabled;
      });
      if (next) { this.select_item(next, true); }
    }
  };

  Filterable.Label = mp.widgets.styled_labels.Rounded;
  Filterable.Body = Body;
  Filterable.Item = mp.widgets.dropdowns.Rounded.Item;
  Filterable.filter_predicate_from_query = filter_predicate_from_query;

  return {
    Filterable,
  };
});

}.call(window));